import React, {Component} from 'react'
import {style} from 'glamor'
import * as colors from '../../colors'
import Page from './Page'
import PageTitle from '../PageTitle'
import Thumb from '../ThumbCategory'

export default class extends Component {

  sshouldComponentUpdate(){
    return false
  }

  render(){
    return (
      <Page>
        <PageTitle>{this.props.title}</PageTitle>
        {this.props.items.map((item, i)=>(
          <Thumb
            data-animate
            title={item.title}
            image={`/images/category/${item.image}`}
            to={ item.items.length > 1
              ? `${this.props.url}/${item.id}`
              : `${this.props.url}/${item.id}/${item.items[0].id}`
            }
            key={i}
          />
        ))}
      </Page>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/pages/Gallery.js
 **/